import { render, staticRenderFns } from "./groupPage.vue?vue&type=template&id=b2920bdc&scoped=true&"
import script from "./groupPage.vue?vue&type=script&lang=js&"
export * from "./groupPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2920bdc",
  null
  
)

export default component.exports